import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Card.css';

const Card = ({ data }) => {
  const navigate = useNavigate();
  
  const {
    id,
    nombre,
    precio_una_hora,
    precio_media_hora,
    fotos,
    categoria_plan
  } = data;

  const imagen = fotos ? `${process.env.REACT_APP_UPLOADS_URL}/ID_${id}/${encodeURIComponent(fotos.split(',')[0])}?v=${id}` : `${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`;

  const handleCardClick = () => {
    navigate(`/perfil?id=${id}&public=1`);
  };

  const isPremium = categoria_plan === 'Premium';
  const isDestacado = categoria_plan === 'Destacado';

const cardContent = (
    <div
      className={`profile-card${!fotos ? ' profile-card-sinfoto' : ''}`}
      onClick={handleCardClick}
      style={{ backgroundImage: `url(${imagen})` }}
    >
      <div className="profile-card-nombre">
        {nombre}
      </div>
      <div className="profile-card-precios">
        <span className="profile-card-precio-item">
          <span className="precio-label">1 Hora</span>
          <span className="precio-valor">${precio_una_hora}</span>
        </span>
        <span className="profile-card-precio-item">
          <span className="precio-label">Media hora</span>
          <span className="precio-valor">${precio_media_hora}</span>
        </span>
      </div>
    </div>
  );

  if (isPremium) {
    return (
      <div className="premium-card-wrapper">
        {cardContent}
      </div>
    );
  }

  return cardContent;
};

export default Card;